module.exports = __webpack_public_path__ + "static/media/3-5-ukrizovan.43f76f5c.jpg";